import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_ACCOUNTSOVERVIEW_ENDPOINT } from './../../shared/constants';
import { IBalance } from '../../shared/interfaces/balance.interface';
import { Observable } from 'rxjs/internal/Observable';

interface ISource {
  source: any;
}

interface IAccountActions {
  name: string;
  url: string;
}

interface IProduct {
  accountActions: Array<IAccountActions>;
  accountId: string;
  accountNumber: string;
  availableBalance: IBalance;
  portfolioName?: string;
  bookBalance: IBalance;
  description: string;
  isCreditCard?: boolean;
  isLinkActive: boolean;
  limit: number | null;
  status: string;
  visible: boolean;
  accountName: string;
  isDefaultAccount?: boolean;
  portfolioId?: string;
}

interface IAccount {
  id: string;
  isCorporate: boolean;
  isDefault: boolean;
  isJoint: boolean;
  isSingle: boolean;
  name: string;
  products: IProduct[];
  source: ISource;
}

interface AccountOverviewResponse extends ApiResponse {
  cards: Array<IAccount> | null;
  portfolios: Array<IAccount> | null;
  source: null;
}

@Injectable({
  providedIn: 'root'
})
export class AccountOverviewService extends ApiClientService {
  private storedDate: AccountOverviewResponse;

  constructor(http: HttpClient) {
    super(http, AB_API_ACCOUNTSOVERVIEW_ENDPOINT);
  }

  // saveOnce is used after login for store the data return by server.
  // The call are make after success login because we need to have user permissions
  // before Layout service return navigation data
  getAccountOverview(saveOnce?: boolean): Observable<AccountOverviewResponse> {
    return Observable.create(observer => {
      if (this.storedDate) {
        observer.next(this.storedDate);
        this.storedDate = null;
        return;
      }

      this.get().subscribe(
        result => {
          if (saveOnce) {
            this.storedDate = result;
          }

          observer.next(result);
        },
        error => {
          observer.next(error);
        }
      );
    });
  }
}

export { AccountOverviewResponse, IAccount, IProduct };
